<div class="grid">
  <div class="col-4"></div>
  <div class="col-4">
    <h1 class="center">ようこそ</h1>
    <div class="center">{{ user.email }} さん</div>
    <p-panel header="新規会員登録">
      <form
        [formGroup]="form"
        #formDir="ngForm">
        <div class="field grid">
          @if (checkFail) {
            <div class="col-12">
              <p-message severity="error">認証コードが間違っているかすでに登録されています</p-message>
            </div>
          }

          <div
            class="col-12"
            style="margin-top: 5px">
            <div class="custom-iconfield">
              <i class="pi pi-lock"></i>
              <input
                type="text"
                class="ng-dirty ng-invalid"
                formControlName="authCode"
                pInputText
                placeholder="メールに届いた4桁の認証コード" />
            </div>
            @if (isAuthCodeRequired()) {
              <p-message severity="error">認証コードは必須です</p-message>
            }
          </div>

          <div
            class="col-12"
            style="margin-top: 12px">
            <div class="custom-iconfield">
              <i class="pi pi-key"></i>
              <input
                type="password"
                class="ng-dirty ng-invalid"
                formControlName="password"
                pPassword
                placeholder="登録するパスワード" />
            </div>
            @if (isPasswordRequired()) {
              <p-message severity="error">パスワードは必須です</p-message>
            }
            @if (isPasswordLength()) {
              <p-message severity="error">パスワードは8文字以上です</p-message>
            }
          </div>

          <div
            class="col-12"
            style="margin-top: 12px">
            <div class="custom-iconfield">
              <i class="pi pi-key"></i>
              <input
                type="password"
                class="ng-dirty ng-invalid"
                formControlName="passwordCheck"
                pPassword
                placeholder="登録するパスワード(確認用)" />
            </div>
            @if (isPasswordCheckRequired()) {
              <p-message severity="error">パスワードは必須です</p-message>
            }
            @if (isPasswordCheckLength()) {
              <p-message severity="error">パスワードは8文字以上です</p-message>
            }
            @if (!isSamePassword()) {
              <p-message severity="error">パスワードが一致しません</p-message>
            }
          </div>

          <div
            class="col-12 center btn-full"
            style="margin-top: 12px">
            <p-button
              label="らくじゃんに登録する"
              styleClass="p-button-info"
              (click)="doRegist()"
              [disabled]="formDir.form.invalid || !isSamePassword()"></p-button>
          </div>
        </div>
      </form>
    </p-panel>
  </div>
  <div class="col-4"></div>
</div>
